import './managers.less';

import React from 'react';
import {Button, Popconfirm, Tabs} from 'antd';
import ProtectedLayout from '../../common/protected-layout';
import {inject, observer} from 'mobx-react';
import {Loading} from '../../common/loading';
import {Link, Route} from 'react-router-dom';
import {ManagersAdd} from './add';
import {ChangePassword} from './change-password';
import {AdminUsers} from './users';

const { TabPane } = Tabs;

@inject('usersStore')
@inject('loginStore')
@observer
export class Managers extends React.Component {

  state = {
    currentTab: 'users',
  };

  componentWillMount() {
    this.props.usersStore.loadAll();
  }



  render() {
    const { isLoading } = this.props.usersStore;

    return (
      <ProtectedLayout className={'managers-list'} onLogout={this.props.loginStore.logout}>
        {isLoading ? <Loading /> : this.renderContent()}
      </ProtectedLayout>
    );
  }

  renderContent() {
    const all = this.props.usersStore.managers;

    const managers = [];
    const users = [];

    for (const user of all) {
      if (user.type === 'user') {
        users.push(user);
      } else {
        managers.push(user);
      }
    }

    return (
      <div className="managers-control">

        <Tabs defaultActiveKey={this.state.currentTab} onChange={::this.changeTab} className="manager-control-tabs">
          <TabPane tab="Менеджеры" key="managers">
            {this.renderManagers(managers)}
            <Route path={'/admin/managers/add'} component={ManagersAdd} />
          </TabPane>
          <TabPane tab="Пользователи" key="users">
            {this.renderUsers(users)}
          </TabPane>
          <TabPane tab="Смена пароля" key="change-password">
            <ChangePassword loginStore={this.props.loginStore}/>
          </TabPane>
        </Tabs>
      </div>
    );
  }

  changeTab(next) {
    this.setState({ currentTab: next });
  }

  renderManagers(managers) {
    return (
      <React.Fragment>
        <div className="managers-header">
          <h2>Менеджеры</h2>
          <div className="actions">
            <Link to={'/admin/managers/add'}><Button type={'primary'}>Добавить</Button></Link>
          </div>
        </div>
        <div>
          {managers && managers.map(m => (
            <Manager manager={m}
                     key={m.id}
                     onRemove={this.removeManager.bind(this, m)}/>
          ))}
        </div>
      </React.Fragment>

    );
  }

  renderUsers(users) {
    return (
      <React.Fragment>
        <div className="managers-header">
          <h2>Пользователи</h2>
        </div>
        <AdminUsers users={users} onRemove={this.removeManager.bind(this)} />
      </React.Fragment>
    );
  }

  removeManager(manager) {
    this.props.usersStore.remove(manager.id);
  }

}



export function Manager({ manager, onRemove }) {
  return (
    <div className="manager-item">
      <div className="info">{manager.email}</div>
      {manager.type !== 'admin' && (
        <div className="actions">
          <Popconfirm title="Вы действительно хотите удалить менеджера?" onConfirm={onRemove}>
            <div className="action">Удалить</div>
          </Popconfirm>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/pages/admin/managers.js